import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaTrash, FaTicketAlt, FaTimes } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { DashboardLoader } from "../../../../components/Loader";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { baseURL, baseURlNoAPI } from "../../../../network/baseUrl.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HeroSection from "../../../../components/HeroSection/HeroSection.js";
import { getLanguage } from "../../../../redux/slices/languageSlice";
import {
  deleteProtected,
  getProtected,
  patchProtected,
  postProtected,
} from "../../../../network/ApiService.js";
const AdminDashboard = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const isUsersView = true;
  const { currentLanguages } = useSelector(getLanguage);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [expandedTicketId, setExpandedTicketId] = useState(null);
  const [showUserEditModal, setShowUserEditModal] = useState(false);
  const [isUpdatingUser, setIsUpdatingUser] = useState(false);
  const [refreshUser, setRefreshUser] = useState(false);
  const [newManager, setNewManager] = useState({
    first_name: "",
    last_name: "",
    email: "",
    // password: "",
    role: "",
    assigned_roles: "",
  });

  const AVAILABLE_ROLES = [
    { value: "asset_manager", label: "Asset Manager" },
    { value: "warehouse_manager", label: "Warehouse Manager" },
    { value: "customer_manager", label: "Customer Manager" },
    { value: "sales_manager", label: "Sales Manager" },
    { value: "finance_manager", label: "Finance Manager" },
  ];

  const handleRoleCheckboxChange = (roleValue) => {
    setNewManager((prev) => {
      let updatedRoles = Array.isArray(prev.assigned_roles)
        ? [...prev.assigned_roles]
        : [];

      if (updatedRoles.includes(roleValue)) {
        // Remove the role if it's already selected
        updatedRoles = updatedRoles.filter((role) => role !== roleValue);
        console.log("check", updatedRoles);
      } else {
        // Add the role if it's not already selected
        updatedRoles.push(roleValue);
      }

      // Set the primary role (first selected role) as the main role
      const primaryRole = updatedRoles.length > 0 ? updatedRoles[0] : "";
      console.log("check1", primaryRole, updatedRoles);
      return {
        ...prev,
        role: primaryRole, // Update the primary role
        assigned_roles: updatedRoles, // Update the assigned roles array
      };
    });
  };
  const [currentUser, setCurrentUser] = useState(null);
  const [userFilters, setUserFilters] = useState({
    role: "",
    status: "",
  });
  const [showLogoutLoader, setShowLogoutLoader] = useState(false);
  const [newTicket, setNewTicket] = useState({
    title: "",
    status: "new",
    priority: "high",
    department: "sales",
    description: "",
    category: "technical",
    customer_name: "",
    customer_company: "",
    customer_phone: "",
    customer_number: "",
    customer_email: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [ticketComments, setTicketComments] = useState({});
  // const [ticketsPerPage] = useState(15);
  const [itemsPerPage] = useState(10);
  const [usersPerPage] = useState(10);
  const [currentUserPage, setCurrentUserPage] = useState(1);
  const [dashboardData, setDashboardData] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [ticketReplies, setTicketReplies] = useState({});
  const [replyText, setReplyText] = useState("");
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setCurrentUserPage(pageNumber);
  };
  const [creatingTicket, setCreatingTicket] = useState(false);

  const [isViewLoading, setIsViewLoading] = useState(false);
  const [isCreatingTicket, setIsCreatingTicket] = useState(false);
  const [isCreatingManager, setIsCreatingManager] = useState(false);
  const handleSearch = () => {
    console.log("Searching for:", searchQuery);
    // Reset pagination when searching
    setCurrentPage(1);
    setCurrentUserPage(1);
  };

  const [increaseZindex, setIncreaseZindex] = useState(false);
  useEffect(() => {
    const handleDashboardUpdate = (event) => {
      const { data } = event.detail;
      if (data.adminData) {
        setDashboardData(data.adminData);
      }
    };

    window.addEventListener("updateDashboardData", handleDashboardUpdate);
    return () =>
      window.removeEventListener("updateDashboardData", handleDashboardUpdate);
  }, []);

  const refreshToken = async () => {
    const refresh = localStorage.getItem("refresh");

    if (!refresh) {
      throw new Error("No refresh token available");
    }

    try {
      const response = await axios.post(`${baseURlNoAPI}/api/token/refresh/`, {
        refresh: refresh,
      });

      const newAccessToken = response.data.access;
      localStorage.setItem("access", newAccessToken);
      return newAccessToken;
    } catch (error) {
      localStorage.removeItem("access");
      localStorage.removeItem("refresh");
      throw new Error("Failed to refresh token");
    }
  };

  const fetchUsers = async () => {
    setLoading(true);
    const url = `${baseURL}/auth/user-management/`;
    try {
      const response = await getProtected(url);
      setUsers(response);
      console.log("fetch users api = ", response);
      setLoading(false);
      return response;
    } catch (err) {
      toast.error(t("loginToasters.genericError"));
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [refreshUser, currentLanguages]);

  const validateManagerEmail = (email) => {
    const emailRegex =
      /^[^\s@]+@[^\s@]+\.(com|uk|eu|de|fr|it|es|nl|be|se|pl|in|io)$/;
    return emailRegex.test(email);
  };

  const resetManagerForm = () => {
    setNewManager({
      first_name: "",
      last_name: "",
      email: "",
      // password: "",
      role: "",
      assigned_roles: "",
    });
  };

  const handleCloseCreateModal = () => {
    setNewManager({
      first_name: "",
      last_name: "",
      email: "",
      // password: "",
      role: "",
      assigned_roles: "",
    });
    setShowCreateModal(false);
    setShowUserEditModal(false);

    // Reset current user when closing edit modal
    setCurrentUser(null);
  };

  const handleCreateManager = async (e) => {
    e.preventDefault();
    if (!validateManagerEmail(newManager.email)) {
      return;
    }
    setIsCreatingManager(true);
    const token = localStorage.getItem("access");

    const url = `${baseURL}/auth/user-management/`;
    const payload = {
      first_name: newManager.first_name,
      last_name: newManager.last_name,
      email: newManager.email,
      role: newManager.role,
    };
    try {
      const response = await postProtected(url, payload);
      toast.success(t("dashboardToasters.managerCreationSuccess"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      if (response.status === 201 || response.status === 200) {
        // Add the new manager to the users list

        const newManagerData = response.data;
        setUsers((prevUsers) => [newManagerData, ...prevUsers]);

        // Reset form and close modal
        resetManagerForm();
        setShowCreateModal(false);
        const updatedUsersResponse = await fetchUsers(token);
        setUsers(updatedUsersResponse.data);
      }
    } catch (error) {
      console.error("Error creating manager:", error);
      if (error.status === 400 && error?.response?.data?.errors?.email?.[0]) {
        toast.error(
          error?.response?.data?.errors?.email?.[0] ||
            t("dashboardToasters.managerWithThisEmailExists"),
          {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          }
        );
      } else {
        toast.error(
           t("dashboardToasters.genricError"),
          {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          }
        );
      }
    } finally {
      setNewManager({
        first_name: "",
        last_name: "",
        email: "",
        // password: "",
        role: "",
        assigned_roles: "",
      });
      setIsCreatingManager(false);
      setShowCreateModal(false);
      setRefreshUser((prev) => !prev);
    }
  };

  const handleDeleteUser = async (userId) => {
    try {
      const url = `${baseURL}/auth/user-management/${userId}/`;
      await deleteProtected(url);
      setUsers((prevUsers) => prevUsers.filter((user) => user.id !== userId));
      toast.success(t("dashboardToasters.userDeletionSuccess"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      setRefreshUser((prev) => !prev);
    } catch (error) {
      // console.error(t("dashboardToasters.genricError"), error);
      toast.error(t("dashboardToasters.genricError"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    }
  };
  // Update the handleEditUser function
  const handleEditUser = async (userId) => {
    try {
      const userToEdit = users.find((user) => user.id === userId);
      if (userToEdit) {
        console.log("user to edit = ", userToEdit);
        setCurrentUser(userToEdit);
        setNewManager({
          first_name: userToEdit.first_name || "",
          last_name: userToEdit.last_name || "",
          email: userToEdit.email || "",
          role: userToEdit.role || "",
          // assigned_roles: Array.isArray(userToEdit.assigned_roles)
          //   ? userToEdit.assigned_roles
          //   : userToEdit.role
          assigned_roles: Array.isArray(userToEdit.assigned_roles)
            ? userToEdit.assigned_roles
            : [userToEdit.role],
          // password: '' // Usually don't pre-fill password
        });
        setShowUserEditModal(true);
      }
    } catch (error) {
      console.error("Error editing user:", error);
      toast.error(t("dashboardToasters.genricError"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    }
  };

  const handleSaveUserEdit = async (e) => {
    e.preventDefault();
    setIsUpdatingUser(true);

    try {
      const secondaryRoles = newManager.assigned_roles.filter(
        (role) => role !== currentUser.role
      );

      // Create payload with the required format
      const payload = {
        first_name: newManager.first_name,
        last_name: newManager.last_name,
        email: newManager.email,
        role: newManager.assigned_roles[0], // Keep the original primary role
        assigned_roles: newManager?.assigned_roles, // Only include secondary roles
      };
      const url = `${baseURL}/auth/assign-roles/${currentUser.id}/`;
      const response = await patchProtected(url, payload);
      toast.success(t("dashboardToasters.userUpdationSuccess"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      if (response.status === 200) {
        setShowUserEditModal(false);

        // Reset form
        setNewManager({
          first_name: "",
          last_name: "",
          email: "",
          // password: "",
          role: "",
          assigned_roles: [],
        });
        setCurrentUser(null);
      }
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error(t("dashboardToasters.userUpdatgenricErrorionSuccess"));
    } finally {
      setIsUpdatingUser(false);
      setShowUserEditModal(false);
      setRefreshUser((prev) => !prev);
    }
  };
  const renderUserRole = (user) => {
    // If primary role exists, show it, otherwise check assigned_roles
    if (user.role) {
      return user.role.replace(/_/g, " ");
    } else if (user.assigned_roles && user.assigned_roles.length > 0) {
      // If no primary role but has assigned roles, show the first assigned role
      return user.assigned_roles[0].replace(/_/g, " ");
    }
    return "N/A";
  };

  const filteredUsers = () => {
    if (!users) return [];
    const query = searchQuery.toLowerCase();

    return users.filter((user) => {
      // Add null checks for each property
      const fullName = `${user.first_name || ""} ${
        user.last_name || ""
      }`.trim();
      const matchesSearch =
        fullName.toLowerCase().includes(query) ||
        (user.email?.toLowerCase() || "").includes(query) ||
        (user.role?.toLowerCase() || "").replace("_", " ").includes(query);

      const matchesRole =
        userFilters.role === "" || user.role === userFilters.role;

      return matchesSearch && matchesRole;
    });
  };

  useEffect(() => {
    const handleRefreshTickets = async (event) => {
      try {
        setLoading(true);
        const token = localStorage.getItem("access");
        const language = localStorage.getItem("selectedLanguage") || "en";
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        const url = `${baseURL}/tickets/?target_language=${currentLanguages}`;
        const response = await axios.get(url, { headers });
        // setTickets(response.data);
      } catch (error) {
        console.error("Error fetching tickets:", error);
        setError("Failed to load tickets");
      } finally {
        setLoading(false);
      }
    };

    window.addEventListener("refreshTickets", handleRefreshTickets);
    return () =>
      window.removeEventListener("refreshTickets", handleRefreshTickets);
  }, [currentLanguages]);

  const UserPagination = () => {
    const filteredUsersList = filteredUsers();
    const totalPages = Math.ceil(filteredUsersList.length / usersPerPage);
    const pageNumbers = [];

    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }

    return (
      <div className="flex flex-wrap items-center justify-between gap-2 bg-white p-2 ">
        <div className="flex items-center space-x-1">
          <button
            onClick={() => setCurrentUserPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentUserPage === 1}
            className="px-3 py-1 text-sm  bg-[#007bff] text-white disabled:bg-blue-300 disabled:cursor-not-allowed"
          >
            {t("pagination.previous")}
          </button>

          <div className="hidden sm:flex items-center space-x-1">
            {Array.from({ length: Math.min(totalPages, 10) }, (_, i) => {
              const pageNum = i + 1;
              const showPage =
                pageNum <= 2 ||
                pageNum > totalPages - 2 ||
                (pageNum >= currentUserPage - 1 &&
                  pageNum <= currentUserPage + 1);

              if (!showPage && pageNum === 3) {
                return (
                  <span key="ellipsis1" className="px-1">
                    ...
                  </span>
                );
              }

              if (!showPage && pageNum === totalPages - 2) {
                return (
                  <span key="ellipsis2" className="px-1">
                    ...
                  </span>
                );
              }

              if (showPage) {
                return (
                  <button
                    key={pageNum}
                    onClick={() => handlePageChange(pageNum)}
                    className={`px-3 py-1 text-sm  ${
                      currentUserPage === pageNum
                        ? "bg-[#007bff] text-white"
                        : "bg-blue-100 text-blue-600 hover:bg-blue-200"
                    }`}
                  >
                    {pageNum}
                  </button>
                );
              }
              return null;
            })}
          </div>

          <button
            onClick={() =>
              setCurrentUserPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentUserPage === totalPages}
            className="px-3 py-1 text-sm  bg-[#007bff] text-white disabled:bg-blue-300 disabled:cursor-not-allowed"
          >
            {t("pagination.next")}
          </button>
        </div>

        <span className="text-sm text-gray-600">
          {t("pagination.page")} {totalPages === 0 ? 0 : currentUserPage}{" "}
          {t("pagination.of")} {totalPages}
        </span>
      </div>
    );
  };

  const getPaginatedUsers = () => {
    if (!users) return []; // Add check for users array

    const filtered = filteredUsers();
    const startIndex = (currentUserPage - 1) * usersPerPage;
    const endIndex = startIndex + usersPerPage;
    return filtered.slice(startIndex, endIndex);
  };

  useEffect(() => {
    setCurrentUserPage(1);
  }, [searchQuery, userFilters]);

  if (showLogoutLoader) {
    return (
      <div className="loader-overlay">
        <div className="loader-content">
          <div className="modern-loader"></div>
          <div className="loader-text">Logging out...</div>
        </div>
      </div>
    );
  }

  const handleClickUser = (userId) => {
    setIncreaseZindex(true);
    setExpandedTicketId(userId);
  };

  if (loading) {
    return <DashboardLoader message={"Loading Users ..."} />;
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center text-center p-6 sm:p-8 md:p-10 lg:p-12  shadow-md bg-red-100 border border-red-400 w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl mx-auto">
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-red-700 font-medium">
          {error}
        </p>
        <button
          onClick={() => window.location.reload()}
          className="px-5 py-2.5 mt-4 text-white bg-red-500  hover:bg-red-600 transition-all duration-200 text-sm sm:text-base md:text-lg lg:text-xl"
        >
          Retry
        </button>
      </div>
    );
  }

  const getPlainTextFromHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const handleRoleRadioChange = (selectedRole) => {
    setNewManager((prev) => ({
      ...prev,
      assigned_roles: [selectedRole],
    }));
  };

  return (
    <div className="admin-dashboard  w-full max-w-full  flex flex-col min-h-screen  bg-gray-50 ">
      {isUsersView ? (
        <>
          <HeroSection
            {...{ t, handleSearch, setSearchQuery, searchQuery, isUsersView }}
          />
        </>
      ) : (
        <>
          <HeroSection {...{ t, handleSearch, setSearchQuery, searchQuery }} />
        </>
      )}

      {/* Controls Section */}
      {/* Dashboard component with responsive design using Tailwind CSS */}
      <div
        className={`w-full  bg-white px-4 sm:px-2 ${
          increaseZindex ? "z-[60]" : ""
        }`}
      >
        {/* Users View Section */}
        {isUsersView && (
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center my-4 space-y-4 md:space-y-0">
            <div>
              <h1 className="text-xl md:text-2xl font-bold">
                {t("usersModal.allUsers")}
              </h1>
            </div>
            <button
              className="bg-[#007bff] hover:bg-blue-700 text-white py-2 px-4  flex items-center space-x-2 text-sm md:text-base w-full md:w-auto justify-center"
              onClick={() => setShowCreateModal(true)}
            >
              <FaTicketAlt />
              <span> {t("usersModal.createManager")}</span>
            </button>
          </div>
        )}

        {/* Content Table */}
        {isUsersView ? (
          <div className={`bg-[#f9f9f9] z-[60]`}>
            {getPaginatedUsers().length === 0 ? (
              <div className="flex flex-col items-center justify-center p-8 text-center">
                <h2 className="text-xl font-semibold text-gray-800">
                  {t("usersModal.noUserAvailable")}
                </h2>
              </div>
            ) : (
              getPaginatedUsers().map((user) => {
                if (!expandedTicketId || expandedTicketId === user.id) {
                  return (
                    <div
                      onClick={() => {
                        handleClickUser(user.id);
                      }}
                      key={user.id}
                      className={`border border-gray-200  mb-3 shadow-sm hover:shadow-md transition-all cursor-pointer z-[60] ${
                        expandedTicketId === user.id ? "bg-gray-50" : "bg-white"
                      }`}
                      // onClick={() => handleTicketClick(user.id)}
                    >
                      {/* Collapsed View */}
                      <div className="p-2 z-[60] ">
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
                          <div className="w-full sm:w-3/4">
                            <div className="text-lg font-medium text-gray-900">
                              {`${user.first_name || ""} ${
                                user.last_name || ""
                              }`.trim() || "NO NAME"}
                            </div>
                            <div className="flex flex-col sm:flex-row mt-1 text-sm text-gray-600">
                              <span className="mr-4">
                                {t("navbar.profile.role")}:{" "}
                                {renderUserRole(user)}
                              </span>
                              <span>
                                {" "}
                                {t("dashboard.modal.userEmailAddress")} :{" "}
                                {user.email || "N/A"}
                              </span>
                            </div>
                          </div>
                          <div className="mt-2 sm:mt-0">
                            {expandedTicketId === user.id ? (
                              <button
                                className="p-2 text-gray-600  hover:bg-gray-100"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setExpandedTicketId(null);
                                }}
                              >
                                <FaTimes />
                              </button>
                            ) : (
                              <div className="flex space-x-2">
                                <button
                                  className="p-2 bg-[#007bff] text-white  hover:bg-[#007bff] transition"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditUser(user.id);
                                  }}
                                >
                                  <FaEdit />
                                </button>
                                <button
                                  className="p-2 bg-[#007bff] text-white  hover:bg-[#007bff] transition"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteUser(user.id);
                                  }}
                                >
                                  <FaTrash />
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Expanded View */}
                      {expandedTicketId === user.id && (
                        <div
                          className="fixed inset-0  bg-black bg-opacity-50 flex items-center justify-center  p-4 z-[60] "
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="bg-white  shadow-lg w-full max-w-lg overflow-hidden">
                            <div className="flex justify-end p-4 border-b">
                              <button
                                className="p-2 text-gray-600  hover:bg-gray-100"
                                onClick={() => {
                                  setExpandedTicketId(null);
                                  setIncreaseZindex(false);
                                }}
                              >
                                <FaTimes />
                              </button>
                            </div>
                            <div className="p-6">
                              <div className="mb-4">
                                <label className="font-medium text-gray-700">
                                  Name:
                                </label>
                                <div className="mt-1">
                                  {`${user.first_name || ""} ${
                                    user.last_name || ""
                                  }`.trim() || "N/A"}
                                </div>
                              </div>
                              <div className="mb-4">
                                <label className="font-medium text-gray-700">
                                  {t("navbar.profile.role")}
                                </label>
                                <div className="mt-1 flex flex-wrap gap-2">
                                  {/* Show primary role */}
                                  <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800  text-sm">
                                    {user.role?.replace(/_/g, " ")}
                                  </span>
                                  {/* Show assigned roles */}
                                  {user.assigned_roles &&
                                    Array.isArray(user.assigned_roles) &&
                                    user.assigned_roles.map(
                                      (role, index) =>
                                        role !== user.role && (
                                          <span
                                            key={index}
                                            className="inline-block px-3 py-1 bg-blue-100 text-blue-800  text-sm"
                                          >
                                            {role.replace(/_/g, " ")}
                                          </span>
                                        )
                                    )}
                                </div>
                              </div>
                              <div className="mb-4">
                                <label className="font-medium text-gray-700">
                                  {t("dashboard.modal.userEmailAddress")}
                                </label>
                                <div className="mt-1">{user.email}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                }
                return null;
              })
            )}

            {!expandedTicketId && (
              <div className="mt-3">
                <UserPagination />
              </div>
            )}
          </div>
        ) : (
          <></>
        )}

        {/* Edit User Modal */}
        {showUserEditModal && currentUser && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white  shadow-lg w-full max-w-md mx-auto">
              <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
                <h2 className="text-xl font-semibold text-gray-800">
                  {t("dashboard.modal.editUser")}
                </h2>
                <button
                  className="text-gray-500 hover:text-gray-700 transition-colors focus:outline-none"
                  onClick={() => {
                    setShowUserEditModal(false);
                    setCurrentUser(null);
                    setNewManager({
                      first_name: "",
                      last_name: "",
                      email: "",
                      role: "",
                      assigned_roles: [],
                    });
                  }}
                >
                  <FaTimes size={20} />
                </button>
              </div>
              <form onSubmit={handleSaveUserEdit}>
                <div className="px-6 py-4 max-h-[70vh] overflow-y-auto">
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {t("dashboard.modal.userFirstName")} *
                    </label>
                    <input
                      type="text"
                      value={newManager.first_name}
                      onChange={(e) =>
                        setNewManager({
                          ...newManager,
                          first_name: e.target.value,
                        })
                      }
                      required
                      placeholder={t(
                        "dashboard.modal.userFirstNamePlaceholder"
                      )}
                      className="w-full px-4 py-2 border border-gray-300  focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {t("dashboard.modal.userLastName")} *
                    </label>
                    <input
                      type="text"
                      value={newManager.last_name}
                      onChange={(e) =>
                        setNewManager({
                          ...newManager,
                          last_name: e.target.value,
                        })
                      }
                      required
                      placeholder={t("dashboard.modal.userLastNamePlaceholder")}
                      className="w-full px-4 py-2 border border-gray-300  focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {t("dashboard.modal.userEmailAddress")} *
                    </label>
                    <input
                      type="email"
                      value={newManager.email}
                      onChange={(e) =>
                        setNewManager((prev) => {
                          return { ...prev, email: e.target.value };
                        })
                      }
                      required
                      placeholder={t(
                        "dashboard.modal.userEmailAddressPlaceholder"
                      )}
                      className="w-full px-4 py-2 border border-gray-300  focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {t("dashboard.users.roles.selectRole")} *
                    </label>
                    <div className="space-y-2 md:grid md:grid-cols-2 md:gap-4 md:space-y-0">
                      {AVAILABLE_ROLES.map((role) => (
                        <label
                          key={role.value}
                          className="flex items-center space-x-2 cursor-pointer"
                        >
                          <input
                            className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                            type="radio"
                            name="userRole"
                            value={role.value}
                            checked={newManager.assigned_roles.includes(
                              role.value
                            )}
                            onChange={() => handleRoleRadioChange(role.value)}
                            // disabled={currentUser.role === role.value}
                          />
                          <span className="text-sm text-gray-700">
                            {role.label}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="flex justify-end gap-4 border-t border-gray-200 px-6 py-4">
                  <button
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300  hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                    type="button"
                    onClick={handleCloseCreateModal}
                  >
                    {t("common.cancel")}
                  </button>
                  <button
                    className="px-4 py-2 text-sm font-medium text-white bg-[#007bff]  hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-blue-300 disabled:cursor-not-allowed"
                    type="submit"
                    disabled={
                      isUpdatingUser ||
                      !newManager.first_name ||
                      !newManager.last_name ||
                      !newManager.email ||
                      newManager.assigned_roles.length === 0
                    }
                  >
                    {isUpdatingUser ? (
                      <div className="flex items-center">
                        <svg
                          className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        {t("Updating...")}
                      </div>
                    ) : (
                      t("common.buttons.save")
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Create Manager Modal */}
        {isUsersView && showCreateModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white  shadow-xl w-full max-w-md md:max-w-lg overflow-hidden">
              <div className="flex items-center justify-between border-b p-4">
                <h2 className="text-lg md:text-xl font-semibold">
                  {t("dashboard.modal.createManager")}
                </h2>
                <button
                  className="text-gray-500 hover:text-gray-700 transition-colors"
                  onClick={handleCloseCreateModal}
                >
                  <FaTimes className="text-xl" />
                </button>
              </div>

              <form onSubmit={handleCreateManager}>
                <div className="p-4 space-y-4">
                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      {t("dashboard.modal.userFirstName")} *
                    </label>
                    <input
                      type="text"
                      value={newManager.first_name}
                      onChange={(e) =>
                        setNewManager({
                          ...newManager,
                          first_name: e.target.value,
                        })
                      }
                      required
                      placeholder={t(
                        "dashboard.modal.userFirstNamePlaceholder"
                      )}
                      className="w-full px-3 py-2 border border-gray-300  focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      {t("dashboard.modal.userLastName")} *
                    </label>
                    <input
                      type="text"
                      value={newManager.last_name}
                      onChange={(e) =>
                        setNewManager({
                          ...newManager,
                          last_name: e.target.value,
                        })
                      }
                      required
                      placeholder={t("dashboard.modal.userLastNamePlaceholder")}
                      className="w-full px-3 py-2 border border-gray-300  focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      {t("dashboard.modal.userEmailAddress")} *
                    </label>
                    <input
                      type="email"
                      value={newManager.email}
                      onChange={(e) =>
                        setNewManager({ ...newManager, email: e.target.value })
                      }
                      required
                      placeholder={t(
                        "dashboard.modal.userEmailAddressPlaceholder"
                      )}
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.(com|in|io)$"
                      onBlur={(e) => {
                        if (
                          !validateManagerEmail(e.target.value) &&
                          e.target.value
                        ) {
                          alert(
                            "Enter Email ending with .com, .uk, .eu, .de, .fr, .it, .es, .nl, .be, .se, .pl, .in, or .io"
                          );
                        }
                      }}
                      className="w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      {t("dashboard.users.roles.selectRole")} *
                    </label>
                    <select
                      value={newManager.role}
                      onChange={(e) =>
                        setNewManager({ ...newManager, role: e.target.value })
                      }
                      required
                      className="w-full px-3 py-2 border border-gray-300  focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                    >
                      <option value="">
                        {t("dashboard.users.roles.selectRole")}
                      </option>
                      <option value="asset_manager">Asset Manager</option>
                      <option value="warehouse_manager">
                        Warehouse Manager
                      </option>
                      <option value="customer_manager">
                        {t("dashboard.users.roles.customer_manager")}
                      </option>
                      <option value="sales_manager">
                        {t("dashboard.users.roles.sales_manager")}
                      </option>
                      <option value="finance_manager">Finance Manager</option>
                    </select>
                  </div>
                </div>

                <div className="flex justify-end gap-3 p-4 border-t">
                  <button
                    type="button"
                    onClick={handleCloseCreateModal}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100  hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-400"
                  >
                    {t("common.cancel")}
                  </button>
                  <button
                    type="submit"
                    disabled={
                      isCreatingManager ||
                      !newManager.first_name ||
                      !newManager.last_name ||
                      !validateManagerEmail(newManager.email) ||
                      !newManager.role
                    }
                    className="px-4 py-2 text-sm font-medium text-white bg-[#007bff]  hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isCreatingManager ? (
                      <div className="flex items-center">
                        <svg
                          className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        {t("Creating")}
                      </div>
                    ) : (
                      t("usersModal.createManager")
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
